(function () {
  function nativeSelector(composer) {
    var form = composer.closest('form');
    if (!form) return null;

    return form.querySelector(
      '.product__variants-swatches[data-section-id="' + composer.dataset.sectionId + '"], .product__variants-select[data-section-id="' + composer.dataset.sectionId + '"]'
    );
  }

  function selectNativeOption(composer, position, value) {
    var wrapper = nativeSelector(composer);
    if (!wrapper) return;

    var radio = Array.prototype.find.call(
      wrapper.querySelectorAll('input[type="radio"][data-position="' + position + '"]'),
      function (input) { return input.value === value; }
    );

    if (radio) {
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var select = Array.prototype.find.call(
      wrapper.querySelectorAll('select.js-variant-selector'),
      function (item) { return item.querySelector('option[data-position="' + position + '"]'); }
    );

    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function renderComposer(composer) {
    var pressed = composer.querySelector('[data-mm-offer-button][aria-pressed="true"]');
    var count = pressed ? Number(pressed.dataset.mmCount) : 1;
    var values = [];

    composer.querySelectorAll('[data-mm-slot-row]').forEach(function (row) {
      var active = Number(row.dataset.mmSlotRow) <= count;
      var select = row.querySelector('[data-mm-cushion-slot]');
      row.hidden = !active;
      select.disabled = !active;
      if (active) values.push(select.value);
    });

    var summary = composer.querySelector('[data-mm-cushion-summary]');
    if (summary) summary.textContent = 'Votre composition : ' + values.join(' · ');
  }

  function initializeComposers() {
    document.querySelectorAll('[data-mm-cushion-composer]').forEach(renderComposer);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-offer-button]');
    if (!button) return;

    var composer = button.closest('[data-mm-cushion-composer]');
    composer.querySelectorAll('[data-mm-offer-button]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    selectNativeOption(composer, composer.dataset.offerPosition, button.dataset.mmOfferValue);
    renderComposer(composer);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-mm-mobile-option-select]')) {
      var option = event.target.selectedOptions[0];
      var input = option && document.getElementById(option.dataset.targetId);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (event.target.matches('[data-mm-cushion-slot]')) {
      var composer = event.target.closest('[data-mm-cushion-composer]');
      if (event.target.dataset.mmCushionSlot === '1') {
        selectNativeOption(composer, composer.dataset.motifPosition, event.target.value);
      }
      renderComposer(composer);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeComposers);
  } else {
    initializeComposers();
  }
})();
